import { Injectable, Inject } from '@angular/core';
import { RequestService } from './request.service';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';

@Injectable()
export class TranslateService {
    
    private translations: any = { };

    // inject our translations
    constructor(
    ) {
        this.translations = window['translations'];
    }

    public translate(key: string): string {
        return this.translations[key] || key;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/translate.service.ts